/* eslint-disable no-shadow */

import ufeApi from 'services/api/ufeApi';
import updateProfile from 'services/api/profile/updateProfile';

import constants from 'services/api/profile/constants';
const { EmailSubscriptionTypes, SubscriptionStatus } = constants;

function getNotificationsAndRemindersPreferences(userProfileId) {
    const url = `/api/users/profiles/${userProfileId}?` + 'propertiesToInclude=emailSubscriptionInfo';

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => {
        let promise;

        if (data.errorCode) {
            promise = Promise.reject(data);
        } else {
            const subscriptions = data.emailSubscriptionInfo || [];

            const triggeredSubs = subscriptions.filter(data => data.subscriptionType === EmailSubscriptionTypes.TRIGGERED)[0];

            const subscribed = (triggeredSubs && triggeredSubs.subscriptionStatus === SubscriptionStatus.SUBSCRIBED) || false;

            const prefs = { subscribed };

            promise = Promise.resolve(prefs);
        }

        return promise;
    });
}

function setNotificationsAndRemindersPreferences(prefs) {
    return updateProfile({
        fragmentForUpdate: 'EMAIL_SUBSCRIPTION',
        emailSubscriptionInfo: {
            subScribeToEmails: prefs.subscribed,
            subscriptionType: EmailSubscriptionTypes.TRIGGERED
        }
    });
}

export default {
    getNotificationsAndRemindersPreferences,
    setNotificationsAndRemindersPreferences
};
